module.exports = __webpack_public_path__ + "img/notice2.78f59bb1.svg";